<button
  type="button"
  class="landing-a__scroll-top"
  [class.landing-a__scroll-top--visible]="visible()"
  (click)="scrollTop.emit()"
  [attr.aria-label]="'landing.landing_1.scroll_top' | translate"
>
  <i-tabler name="arrow-up" class="landing-a__scroll-top-icon"></i-tabler>
</button>
